import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the client tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['admin/findClientsWidgetModule/get']
}

/**
 * Returns the sets of selected clients.
 *
 * @return Object
 */
export const selectedClientSets = () => {
  return store.getters['admin/findClientsWidgetModule/clientSelectionSets']
}

/**
 * Returns clients that are selected for the specified set.
 *
 * @param set String
 *
 * @return Object
 */
export const selectedClients = (set) => {
  if (store.getters['admin/findClientsWidgetModule/clientSelectionSets'].hasOwnProperty(set)) {
    return store.getters['admin/findClientsWidgetModule/clientSelectionSets'][set]
  } else {
    return {}
  }
}

/**
 * Returns the first selected client in the specified set or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedClient = (set) => {
  if (store.getters['admin/findClientsWidgetModule/clientSelectionSets'].hasOwnProperty(set)) {
    const clients = store.getters['admin/findClientsWidgetModule/clientSelectionSets'][set]
    const clientIds = Object.keys(clients)
    if (clientIds.length > 0) {
      return clients[clientIds[0]]
    } else {
      return null
    }
  } else {
    return null
  }
}

/**
 * Returns the first selected client's id in the specified set
 * or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedClientId = (set) => {
  const client = selectedClient(set)
  return client === null ? null : client.id
}

/**
 * Returns true if the specified client is selected within the supplied set.
 *
 * @param set String
 * @param id Integer
 *
 * @return Boolean
 */
export const isSelected = (set, id) => {
  return selectedClients(set).hasOwnProperty(id)
}

/**
 * Returns either a client object or null depending on whether
 * queries should be made by client.
 *
 * @return Object|null
 */
export const getClient = () => {
  return store.getters['admin/findClientsWidgetModule/getClient']
}

/**
 * Load the status data of the clients being tracked.
 *
 * @return Promise
 */
export const query = () => {
  return store.dispatch('admin/findClientsWidgetModule/query')
}

/**
 * Add a map or array of object clients that have been selected within
 * the specified set.
 *
 * @param set String
 * @param clients Array|Map
 */
export const addSelectedClients = (set, clients) => {
  store.commit('admin/findClientsWidgetModule/addSelectedClients', { set, clients })
}

/**
 * Set a single selected client, all other selected clients
 * in the set will be cleared.
 *
 * @param set String
 * @param client Object
 */
export const setSelectedClient = (set, client) => {
  store.commit('admin/findClientsWidgetModule/setSelectedClient', { set, client })
}

/**
 * Removes an array of clients from the set's list of selected clients.
 * The array must consist of the id's of the clients that are no
 * longer selected.
 *
 * @param set String
 * @param clients Array
 */
export const removeSelectedClients = (set, clients) => {
  store.commit('admin/findClientsWidgetModule/removeSelectedClients', { set, clients })
}

/**
 * Clears all selected clients within a specified set.
 */
export const clearSelectedClients = (set) => {
  store.commit('admin/findClientsWidgetModule/clearSelectedClients', set)
}

/**
 * Clears all selected clients.
 */
export const clearAllSelectedClients = () => {
  store.commit('admin/findClientsWidgetModule/clearAllSelectedClients')
}

/**
 * Returns the selected client count for the specified set.
 *
 * @param set String
 *
 * @return Integer
 */
export const selectedClientCount = (set) => {
  return Object.keys(selectedClients(set)).length
}

/**
 * Clears all clients from being tracked.
 */
export const purge = () => {
  store.commit('admin/findClientsWidgetModule/purge')
}

/**
 * Sets the client for which the clients should be queried.
 *
 * @param client Object|null
 */
export const setClient = (client) => {
  store.commit('admin/findClientsWidgetModule/setClient', client)
}



// WEBPACK FOOTER //
// ./src/store/administration/clients/findClientsWidget.helpers.js